import React from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import './NotificationList.css';

const NotificationList = ({ notifications }) => {
  if (notifications.length === 0) {
    return (
      <div className="empty-notification">
        <p>No hay notificaciones para mostrar</p>
      </div>
    );
  }
  
  return (
    <div className="notification-list">
      {notifications.map((notification) => (
        <div key={notification.id} className="notification-item">
          <div className="notification-date">
            {format(new Date(notification.date), 'dd/MM/yyyy', { locale: es })}
          </div>
          <div className="notification-content">
            <span className="client-name">{notification.clientName}. </span>
            <span className="message">"{notification.message}"</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationList;